/** Size the scroll window to complete recent messages instead of a fractional first line. */
export function fitChatViewport(list: HTMLElement, atBottom: boolean, options: { rowSelector?: string; maxHeight?: number } = {}) {
  if (!list.clientWidth) return;
  const rows = Array.from(list.querySelectorAll<HTMLElement>(options.rowSelector || ':scope > p'));
  if (!rows.length) return;
  const budget = options.maxHeight || Math.max(96, Math.min(240, window.innerHeight * .28));
  list.style.paddingTop = '0px';
  const listTop = list.getBoundingClientRect().top;
  let height = 0, count = 0;
  for (const row of rows.slice(-5).reverse()) {
    // Measure the actual rendered span: adjacent margins can collapse. Summing
    // the margins exposes a partial older row at the top of a short viewport.
    const start = row.getBoundingClientRect().top - listTop + list.scrollTop;
    const span = list.scrollHeight - start;
    if (count && span > budget) break;
    height = span; count += 1;
  }
  const previous = list.scrollTop;
  const size = `${Math.ceil(Math.min(height, budget))}px`;
  list.style.height = size; list.style.maxHeight = size;
  list.scrollTop = atBottom ? list.scrollHeight : previous;
}

/** Keep the first visible panel message whole while following incoming chat. */
export function fitChatPanel(list: HTMLElement, atBottom: boolean) {
  if (!atBottom || !list.clientWidth) return;
  const padding = 12;
  list.style.paddingBottom = `${padding}px`;
  const maxScroll = Math.max(0, list.scrollHeight - list.clientHeight);
  if (maxScroll) {
    const top = list.getBoundingClientRect().top;
    const row = Array.from(list.querySelectorAll<HTMLElement>(':scope > p')).find(message =>
      message.getBoundingClientRect().top - top + list.scrollTop >= maxScroll - .5);
    if (row) {
      const start = row.getBoundingClientRect().top - top + list.scrollTop;
      list.style.paddingBottom = `${padding + Math.ceil(Math.max(0, start - maxScroll))}px`;
    }
  }
  list.scrollTop = list.scrollHeight;
}
